import { render } from "./Control_Tables.vue?vue&type=template&id=0a3a76c6"
import script from "./Control_Tables.vue?vue&type=script&lang=js"
export * from "./Control_Tables.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../ag-v3-trion/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__